"use client";
import IconWrapper from "@/components/ui/IconWrapper";
import { PATHS } from "@/constants/pathnames";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { Link } from "@/i18n/navigation";
import { getLocalizedPath } from "@/utils/pathUtils";
import { useLocale } from "next-intl";
import Image from "next/image";

function pushSelectPromotionDataLayer(selectPromotionPayload) {
  if (typeof window === "undefined" || !selectPromotionPayload) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "ecom_event",
    event_category: "ecommerce",
    event_action: "select_promotion",
    ecommerce: selectPromotionPayload,
  });
}

export default function CampaignCard({
  item,
  translationNamespace = "common",
  selectPromotionPayload,
}) {
  const {
    CampaignId,
    RedirectSlug,
    Title,
    TitleWithoutHtmlTags,
    ThumbnailImageUrl,
    ThumbnailImageUrlFixed,
    DaysLeft,
  } = item || {};
  const locale = useLocale();

  // const href = RedirectSlug
  //   ? RedirectSlug.startsWith("/")
  //     ? RedirectSlug
  //     : `/${RedirectSlug}`
  //   : "/";
  const href = `${getLocalizedPath(PATHS.CAMPAGINS_DETAIL.PATH, locale).replace(
    "[campaignSlug]",
    RedirectSlug,
  )}?campaignId=${CampaignId}`;
  const titleText = TitleWithoutHtmlTags || Title || "";
  const imageUrl = ThumbnailImageUrlFixed || ThumbnailImageUrl || "";
  const t = useTranslationDetector(translationNamespace);

  const handleClick = () => {
    if (selectPromotionPayload) {
      pushSelectPromotionDataLayer(selectPromotionPayload);
    }
  };


  return (
    <Link
      href={href}
      className="border-border-card flex w-full cursor-pointer flex-col items-start justify-start overflow-hidden rounded-lg border md:basis-[45%] lg:basis-[23.3%] xl:basis-[23.5%]"
      onClick={handleClick}
    >
      <div className="rounded-t-default relative aspect-[291/250] w-full">
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt={titleText || "campaign-image"}
            fill
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 45vw, 23vw"
            className="rounded-t-lg object-cover"
          />
        ) : (
          <div className="bg-background-200 h-full w-full rounded-t-lg" />
        )}
      </div>
      <div className="flex h-full w-full flex-col items-start justify-between gap-[21px] p-4">
        <div className="text-foreground m-0 line-clamp-3 h-[78px] text-lg leading-[26px] font-semibold">
          {titleText}
        </div>

        <div className="flex w-full items-center justify-between">
          <div className="min-h-[28px]">
            {typeof DaysLeft === "number" && DaysLeft > 0 && (
              <p className="text-foreground bg-background-300 rounded-[6px] px-2 py-1 text-xs font-medium">
                {t("daysLeftRemaining", { count: DaysLeft })}
              </p>
            )}
          </div>
          <div className="text-primary flex items-center gap-1">
            <p className="text-sm font-medium">{t("explore")}</p>
            <IconWrapper className="h-5 w-5" name="arrowRight" />
          </div>
        </div>
      </div>
    </Link>
  );
}
